import { initListView, ListView, ListViewColumnType } from "../../UI/view/list-view";
import { ruleGeofencesDataSource } from "./alarm-datasource";

export const geofencedAssets = {
  columns: [
    {
      accessor: 'containerId',
      Header: 'Container Id',
      linkPath: ({val, row}) => `/assets/${row?.original?.assetType == 'gas' ? 'gas-container' : row?.original?.assetType == 'liquid' ? 'liquid-container' : 'chassis'}/${row?.original?.containerId}`,
      type: ListViewColumnType.link
    },
    {
      accessor: 'assetType',
      Header: 'Asset Type'
    },
    {
      accessor: 'dateEntered',
      Header: 'Date Entered',
      type: ListViewColumnType.date
    },
  ]
} as ListView;

export const GeofencedAssetListView = initListView(geofencedAssets, ruleGeofencesDataSource);